export const ROUTES_PREFIX = "/customer";

export const ACCOUNT_ROUTE = ROUTES_PREFIX+ "/account";
export const ACCOUNT_LOGIN_ROUTE = ACCOUNT_ROUTE+ "/login";
export const ACCOUNT_RESET_PASSWORD_ROUTE = ACCOUNT_ROUTE+ "/reset_password";
export const ACCOUNT_FORGOT_PASSWORD_ROUTE = ACCOUNT_ROUTE+ "/forgot_password";
export const ACCOUNT_REGISTER_ROUTE = ACCOUNT_ROUTE+ "/register";
export const ACCOUNT_EDIT_ROUTE = ACCOUNT_ROUTE + "/edit";
export const ACCOUNT_CHANGE_PASSWORD_ROUTE = ACCOUNT_ROUTE + "/pass";
export const BILLING_ADDRESS_ROUTE = ROUTES_PREFIX + "/billing";
export const BILLING_ADDRESS_ADD_ROUTE = BILLING_ADDRESS_ROUTE + "/add";
export const BILLING_ADDRESS_EDIT_ROUTE = BILLING_ADDRESS_ROUTE + "/edit";
export const SHIPPING_ADDRESS_ROUTE = ROUTES_PREFIX + "/shipping";
export const SHIPPING_ADDRESS_EDIT_ROUTE = SHIPPING_ADDRESS_ROUTE + "/edit";
export const SHIPPING_ADDRESS_ADD_ROUTE = SHIPPING_ADDRESS_ROUTE + "/add";
export const ORDER_ROUTE = ROUTES_PREFIX+ "/order";
export const ORDER_VIEW_ROUTE = ORDER_ROUTE+ "/view";
export const EMPTY_ROUTE = ROUTES_PREFIX+ "/empty";